var _path;
function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgShapeSpace6(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 1390,
    height: 50,
    viewBox: "0 0 1390 50",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0 50H1390L1350 0H40L0 50Z",
    fill: "#E3F0FF"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgShapeSpace6);
export default __webpack_public_path__ + "static/media/shape_space_6.0a90139d1cbad7e17625e85f28f5f98c.svg";
export { ForwardRef as ReactComponent };